import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const GLOBAL_APP_SETTINGS = 'global-app-settings';

interface UiSettings {
  isVersionInfoVisible: boolean;
  isHistoryVisibleInSwapPanel: boolean;
  isManualBtcUtxosSelection: boolean;
  isManualLtcUtxosSelection: boolean;
  isManualDogeUtxosSelection: boolean;
}

interface GlobalSettings extends UiSettings {
  language: string;
  setLanguage: (language: string) => void;
  setUiSettings: (settingsUpdate: Partial<UiSettings>) => void;
}

export const useGlobalSettingsStore = create<GlobalSettings>()(
  persist(
    (set) => ({
      language: 'en',
      setLanguage: (language) => set({ language }),
      isVersionInfoVisible: false,
      isHistoryVisibleInSwapPanel: true,
      isManualBtcUtxosSelection: false,
      isManualLtcUtxosSelection: false,
      isManualDogeUtxosSelection: false,
      setUiSettings: (settingsUpdate) => set((state) => ({ ...state, ...settingsUpdate })),
    }),
    {
      name: GLOBAL_APP_SETTINGS,
    }
  )
);
